import {jwtDecode} from "jwt-decode"
import {isEmpty} from "lodash"

export const decodeJWT = (token) => {
  const decoded = jwtDecode(token)
  if (decoded.exp * 1000 < Date.now()) return null
  return decoded
}

export const decodeJWTIgnoreExpiry = (token) => {
  return  jwtDecode(token)
}

export const isExpired = (token) => {
  const decoded = jwtDecode(token)
  return decoded.exp * 1000 < Date.now()
}

export const isExpiringSoon = (token, gracePeriodMs = 10000) => {
  const decoded = jwtDecode(token)
  return decoded.exp * 1000 < Date.now() + gracePeriodMs
}

export const paramsContainNoneEmptyToken = (params) => {
  const {token} = params
  return !isEmpty(token)
}

export const getCompanyLogoUrl = (token) => {
  return `/service/customer/company-logo-read?token=${token}`
}